import Vue from 'vue';
import Configurator from './components/Configurator';
import ConfiguratorSlideOut from './components/ConfiguratorSlideOut';
import Loading from 'vue-loading-overlay';
Vue.component('loading', Loading);

Vue.component('configurator-slide-out', ConfiguratorSlideOut);
Vue.component('configurator', Configurator);

$(document).ready(function () {

    if ($('#productConfigurator').length) {
        let productConfiguratorApp = new Vue({
            el: '#productConfigurator',
            name: 'productConfiguratorApp'
        });
    }

    window.addEventListener('scroll', function() {
        var windowWidth = $(window).width();
        if(windowWidth >= 767){
            if(window.scrollY >= 260){
                $('.current-price').css({ 'visibility':'visible','right':'180px' });
            } else {
                $('.current-price').css({ 'visibility':'hidden','right':'0' });
            }
        } else {
            if(window.scrollY >= 840){
                $('.current-price').css({ 'visibility':'visible','right':'0','bottom':'50px' });
            } else {
                $('.current-price').css({ 'visibility':'hidden','right':'0' });
            }
        }
    });

});